import { useDroppable } from "@dnd-kit/core";
import { Badge, Space } from "antd";
import trans from "../../../utils";

const KanbanColumn = ({
  id,
  count = 0,
  title = "To Do",
  children,
  data,
  viewMode,
}) => {
  const { isOver, setNodeRef, active } = useDroppable({
    id: id,
    data: data,
  });

  const badgeColor = {
    todo: `#1890FF`,
    inProgress: `#FA8C16`,
    done: `#43A047`,
    // delayed: `#F5222D`,
    unassigned: `#42526E`,
  };

  return (
    <div
      ref={setNodeRef}
      style={{
        display: "flex",
        flexDirection: "column",
        margin: "8px",
        height: viewMode === "Kanban" ? "100vh" : "",
        backgroundColor: "#EAF4EC",
        border: "1px solid #BEDDC5",
        borderRadius: "8px",
        minWidth: "24%",
      }}
    >
      <div
        style={{
          padding: "12px 16px",
          backgroundColor: "#EAF4EC",
          borderRadius: "8px",
        }}
      >
        <Space
          style={{
            width: "100%",
            justifyContent: "space-between",
          }}
        >
          <Space>
            <p style={{ margin: 0, fontWeight: "600", fontSize: "16px" }}>
              {trans(title)}
            </p>
            {!!count && <Badge count={count} color={badgeColor[id]} />}
          </Space>
        </Space>
      </div>
      <div
        className="kanban-scroll"
        style={{
          flex: 1,
          overflowY: active ? "unset" : "auto",
          border: "2px dashed transparent",
          borderColor: isOver ? "#000040" : "transparent",
          borderRadius: "4px",
          paddingInline: "8px",
        }}
      >
        <div
          style={{
            marginBlock: "12px",
            display: "flex",
            flexDirection: "column",
            gap: "8px",
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default KanbanColumn;
